import { z } from 'zod';
import { LEAD_LIMITS } from '../types/lead.js';
/**
 * Public submission — what the landing form posts unauthenticated. We trim
 * + normalise email server-side; honeypot rejection happens in the route.
 */
export const CreateLeadRequestSchema = z.object({
    name: z.string().trim().min(1).max(LEAD_LIMITS.nameMaxLen),
    email: z.string().trim().toLowerCase().email().max(LEAD_LIMITS.emailMaxLen),
    phone: z.string().trim().max(LEAD_LIMITS.phoneMaxLen).optional().or(z.literal('')),
    company: z.string().trim().max(LEAD_LIMITS.companyMaxLen).optional().or(z.literal('')),
    subject: z.string().trim().max(LEAD_LIMITS.subjectMaxLen).optional().or(z.literal('')),
    message: z.string().trim().min(1).max(LEAD_LIMITS.messageMaxLen),
});
export const LeadIdParamSchema = z.object({ id: z.string().uuid() });
export const GrantLeadsAccessBodySchema = z.object({ userId: z.string().uuid() });
//# sourceMappingURL=lead.schema.js.map